// extracted by mini-css-extract-plugin
export default {"list":"PaywallPremium_list__HLcXD"};